import React from 'react';
import {genererViews, separateurNumber} from '../../libs/helper';
import Icon from './Icon';

const ViewsComment = ({value = 0, ...props}) => {
    return (
        (props.type === "icon") ? (
            <div className={`views-comment ${props.className || ""}`}>
                <Icon type="comment"/> {separateurNumber(genererViews(value)) || 0}
            </div>
        ) : (
            <div className={`views-comment-text ${props.className || ""}`}>
                {value || 0} commentaire
            </div>
        )
    )
}

export default ViewsComment;
